import axios from "../axiosInstance";

class StatusSocialContractService {
  async getStatusSocialContractList() {
    return await axios.get("statussocialcontract");
  }
}

export default new StatusSocialContractService();
